export const TwoLeftFeet = "/assets/MTLF/2-left-feet-c.webp"
export const TwoLeftFeetTitle = "/assets/MTLF/2lf-title.webp"
export const CoverFly = "/assets/MTLF/coverfly.webp"
export const Opener = "/assets/MTLF/opener.webp"
export const ThatWasAwesome = "/assets/MTLF/that-was-awesome.webp"
export const TheDancer = "/assets/MTLF/the-dancer.webp"
export const BoomBox = "/assets/MTLF/boombox.webp"
export const UhOh = "/assets/MTLF/uh-oh-b.webp"

export const CokeSpec = "/assets/works/10.A-Coca-Cola-Wedding-(:60-Spec).webp"
export const IFOR = "/assets/works/11.An-Inertial-Frame-of-Reference-(3-Poems).webp"
export const TwoLeftFeetPoster = "/assets/works/12.My-Two-Left-Feet.webp"

export const TMNT = "/assets/resume/3.Teenage-Mutant-Ninja-Turtles.webp"
export const TMNT_OUT_THE_SHADOWS = "/assets/resume/6.Teenage-Mutant-Ninja-Turtles-Out-Of-The-Shadows.webp"
export const PENNY_DREADFUL = "/assets/resume/4.Penny-Dreadful.webp"
export const FINEST_HOURS = "/assets/resume/5.The-Finest-Hours.webp"
export const CLOVER_FIELD = "/assets/resume/7.The-Cloverfield-Paradox.webp"
export const VENOM = "/assets/resume/8.Venom.webp"
export const GRAN_TURISMO = "/assets/resume/9.Gran-Turismo.webp"

export const InstagramURL = "/assets/socials/1.instagram.webp"
export const LinkedInURL = "/assets/socials/2.linkedin.webp"
export const THE_KID = "/assets/thekidhimself/damian-2-removebg-preview%20(3).webp"

export const MTLF_FIGHTING_SPIRIT_LAUREL = "/assets/awards/MTLF/1.Fighting_Spirit_Film_Festival_2023_Official_Selection.webp"
export const MTLF_SCREEN_CRAFT_LAUREL = "/assets/awards/MTLF/2.screenscraft_laurel.webp"
export const MTLF_UW_23_LAUREL = "/assets/awards/MTLF/3.UW-23-Official-Selection_white_high_res.webp"
export const MTLF_RED_LIST_LAUREL = "/assets/awards/MTLF/4.MTLF-transformed.webp"

export const MTLF_LOOKBOOK_COVER = "/assets/bg-assets/MTLF-LOOKBOOK-COVER.webp"
export const MTLF_NO_WORDS = "/assets/bg-assets/MTLF-NOWORDS.webp"